import React from "react";
import PropTypes from "prop-types";

const InfoCircleFillIcon = ({
  alt = "Info",
  className = "",
  size = 24,
  onClick = () => {},
}) => (
  <svg
    aria-label={alt}
    className={`wink-icon ${className}`}
    width={size}
    height={size}
    onClick={onClick}
    viewBox="0 0 24 24"
    aria-labelledby="InfoCircleFillIcon"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="InfoCircleFillIcon">{alt}</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm1-16.25a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM9 12v-1l2-1h2v6l2 1v1H9v-1l2-1v-4H9z"
    />
  </svg>
);

InfoCircleFillIcon.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number,
  onClick: PropTypes.func,
};

export default InfoCircleFillIcon;
